<template>
    <div>
        <SideBar></SideBar>

        <div class="vip">
            <div class="vip-block block01">
                <div class="vip-title">
                    <p>威马捷健康管理俱乐部</p>
                    <img :src="card" alt="">
                </div>
                <div class="vip-introduce">
                    <h3>威马捷服务卡介绍</h3>
                    <h4>加入威马捷会员，即可享受威马捷赴日医疗服务。</h4>
                    <div class="vip-items">
                        <div class="vip-item">
                            <img :src="doctor" alt="">
                            <div class="vip-item-info">
                                <h5>日本专家二次诊疗建议</h5>
                                <p>针对100种重大疾病，由日本著名医院多学科专家团队，出具综合诊断报告，帮助患者足不出户得到更加合适的治疗方案。</p>
                            </div>
                        </div>
                        <div class="vip-item">
                            <img :src="doctor1" alt="">
                            <div class="vip-item-info">
                                <h5>赴日就医绿色通道服务</h5>
                                <p>帮助患者在最短的时间内，预约到日本著名医院，安排住院和手术治疗，并提供患者赴日就医过程中所需要的相关资源和一站式服务。</p>
                            </div>
                        </div>
                    </div>
                    <div class="vip-code">
                        <p>微信扫码,轻松激活</p>
                        <img :src="qrcode" alt="">
                    </div>
                </div>
            </div>
            <div class="vip-block block02">
                <div class="vip-steps">
                    <h3>激活流程</h3>
                    <img :src="pointer1" alt="">
                </div>
                <div class="vip-step">
                    <div>
                        <img class="step" :src="step1" alt="">
                        <div class="step-note">
                            <p>进入微信点击“发现”</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step2" alt="">
                        <div class="step-note">
                            <p>点击“搜一搜”</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step3" alt="">
                        <div class="step-note">
                            <p>搜索“威马捷”公众号</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step4" alt="">
                        <div class="step-note">
                            <p>点击“威马捷”</p>
                            <p>进入公众号</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vip-block block03">
                <div class="vip-step">
                    <div>
                        <img class="step" :src="step5" alt="">
                        <div class="step-note">
                            <p>点击“关注公众号”</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step6" alt="">
                        <div class="step-note">
                            <p>进入公众号后</p>
                            <p>点击“用户中心”</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step7" alt="">
                        <div class="step-note">
                            <p>点击“会员卡激活”</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step8" alt="">
                        <div class="step-note">
                            <p>输入卡号和激活码，</P>
                            <p>点击 “下一步”</p>
                        </div>
                    </div>
                    <div>
                        <img class="step" :src="step9" alt="">
                        <div class="step-note">
                            <p>确认会员服务协议和个人</p>
                            <p>信息保护同意书后，</p>
                            <p>点击确认并开始提交激活。</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step10" alt="">
                        <div class="step-note">
                            <p>填写完毕手机号后，</p>
                            <p>点击“发送验证码”</p>
                            <p>查看短信验证码并输入。</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step11" alt="">
                        <div class="step-note">
                            <p>进入会员信息页面并填写</p>
                            <p>个人信息后点击</p>
                            <p>“提交激活”</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step12" alt="">
                        <div class="step-note">
                            <p>激活成功后点击</p>
                            <p>“查看我的会员卡”</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vip-block block04">
                <div class="vip-step">
                    <div>
                        <img class="step" :src="step13" alt="">
                        <div class="step-note">
                            <p>可以查看激活的卡片信息。</p>
                        </div>
                    </div>
                    <img class="step-point" :src="pointer2" alt="">
                    <div>
                        <img class="step" :src="step14" alt="">
                        <div class="step-note">
                            <p>也可以在我的会员里</p>
                            <p>直接查看激活的卡片信息。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import card from '@/assets/images/vip/card.png'
import doctor from '@/assets/images/vip/doctor.jpg'
import doctor1 from '@/assets/images/vip/doctor1.jpg'
import qrcode from '@/assets/images/vip/qrcode.png'
import pointer1 from '@/assets/images/vip/pointer1.png'
import pointer2 from '@/assets/images/vip/pointer2.png'
import step1 from '@/assets/images/vip/new-step1.jpg'
import step2 from '@/assets/images/vip/new-step2.jpg'
import step3 from '@/assets/images/vip/new-step3.jpg'
import step4 from '@/assets/images/vip/new-step4.jpg'
import step5 from '@/assets/images/vip/new-step5.jpg'
import step6 from '@/assets/images/vip/new-step6.jpg'
import step7 from '@/assets/images/vip/new-step7.jpg'
import step8 from '@/assets/images/vip/new-step8.jpg'
import step9 from '@/assets/images/vip/new-step9.jpg'
import step10 from '@/assets/images/vip/new-step10.jpg'
import step11 from '@/assets/images/vip/new-step11.jpg'
import step12 from '@/assets/images/vip/new-step12.jpg'
import step13 from '@/assets/images/vip/new-step13.jpg'
import step14 from '@/assets/images/vip/new-step14.jpg'
import SideBar from "@/components/SideBar"

export default {
    data(){
        return {
            card,
            doctor,
            doctor1,
            qrcode,
            pointer1,
            pointer2,
            step1,
            step2,
            step3,
            step4,
            step5,
            step6,
            step7,
            step8,
            step9,
            step10,
            step11,
            step12,
            step13,
            step14,
        }
    },
  components: {
    // Bread
    SideBar
  },
    created(){
      document.title = '赴日医疗福卡-海外医疗-出国看病-远程咨询-第二诊疗-二次诊断-威马捷'
    }
}
</script>
<style lang="less" scoped>
.vip{
    width: 100%;
    margin:  0 auto;
    .vip-block{
        background-size: 100% 100%;
        background-position: center;
        overflow: hidden;
    }
    .block01{
        height: 970px;
        background-image: url("../assets/images/vip/bg-01.png");
    }
    .block02{
        background-image: url("../assets/images/vip/bg-02.png")
    }
    .block03{
        height: 1085px;
        background-image: url("../assets/images/vip/bg-03.png")
    }
    .block04{
        height: 1034px;
        background-image: url("../assets/images/vip/bg-04.png")
    }
    .vip-title{
        text-align: center;
        margin: 100px 0 120px;
        p{
            width: 320px;
            height: 45px;
            background: #fff;
            color: #266090;
            font-size: 26px;
            line-height: 45px;
            margin: 0 auto 18px;
        }
    }
    .vip-introduce{
        width: 970px;
        background: #fff;
        border-radius: 8px;
        padding: 30px 0;
        margin: 0 auto;
        h3{
            font-size: 24px;
            color: #353535;
            line-height: 44px;
            text-align: center;
        }
        h4{
            font-size: 14px;
            color: #3f3f3f;
            line-height: 34px;
            text-align: center;
        }
        .vip-items{
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-around;
            margin: 30px 0 50px;
            .vip-item{
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: space-between;
                width: 420px;
                img{
                   width: 188px;
                    margin-right: 18px;
                }
            }
            .vip-item-info{
                display: flex;
                flex-flow: column wrap;
                align-items: flex-start;
                justify-content: space-around;
                h5{
                    font-size: 18px;
                    color: #0b0b0b;
                }
                p{
                  margin-top: 10px;
                    font-size: 14px;
                    line-height: 26px;
                    color: #505050;
                }
            }
        }
        .vip-code{
            text-align: center;
            p{
                font-size: 14px;
                line-height: 24px;
                color: #3f3f3f;

            }
        }
    }
    .vip-steps{
        text-align: center;
        h3{
            color: #fff;
            font-size: 36px;
            line-height: 76px;
        }
        margin-bottom: 55px;
    }
    .vip-step{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        width: 970px;
        margin: 0 auto;
        .step-point{
            align-self: center;
            margin: 0 18px;
        }
        .step{
            width: 200px;
            height: 405px;
            margin-bottom: 25px;
        }
        .step-note{
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            width: 200px;
            height: 60px;
            background: #4a7ba6;
            border-radius: 4px;
            margin-bottom: 55px;
            p{
                font-size: 14px;
                color: #fff;
                line-height: 20px;
            }
        }
    }
}
</style>